
import AppPromo from "@/components/AppPromo";
import Footer from '@/components/Footer';
import Header from '@/components/HeaderUpdated';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

const AboutUs = () => {
  const { t } = useLanguage();

  return (
    <div className="min-h-screen flex flex-col bg-brand-darker text-white">
      <Header />
      <main className="flex-grow pt-32 pb-16">
        <section className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center mb-16">
            <div className="order-2 lg:order-1">
              <h1 className="text-4xl md:text-5xl font-bold mb-6">{t('about.title')}</h1>
              <h2 className="text-2xl font-semibold mb-4">{t('about.subtitle')}</h2>
              <p className="text-gray-300 mb-6">
                {t('about.description')}
              </p>
              
              <Accordion type="single" collapsible className="w-full">
                <AccordionItem value="item-1" className="border-b border-gray-700">
                  <AccordionTrigger className="text-left py-4 hover:no-underline">{t('about.scope')}</AccordionTrigger>
                  <AccordionContent className="text-gray-300 pb-4">
                    {t('about.scopeContent')}
                  </AccordionContent>
                </AccordionItem>
                
                <AccordionItem value="item-2" className="border-b border-gray-700">
                  <AccordionTrigger className="text-left py-4 hover:no-underline">{t('about.participants')}</AccordionTrigger>
                  <AccordionContent className="text-gray-300 pb-4">
                    {t('about.participantsContent')}
                  </AccordionContent>
                </AccordionItem>
                
                <AccordionItem value="item-3" className="border-b border-gray-700">
                  <AccordionTrigger className="text-left py-4 hover:no-underline">{t('about.pointsEarning')}</AccordionTrigger>
                  <AccordionContent className="text-gray-300 pb-4">
                    <p className="mb-2">{t('about.pointsContent1')}</p>
                    <p className="mb-2">{t('about.pointsContent2')}</p>
                    <p className="mb-2">{t('about.pointsContent3')}</p>
                    
                    <p>A Dartsbeat.com manterá, num registo automatizado, o saldo de pontos correspondentes
a cada utilizador, o qual poderá ser consultado na app móvel Dartsbeat User para este
efeito.</p>
                  </AccordionContent>
                </AccordionItem>
                
                <AccordionItem value="item-4" className="border-b border-gray-700">
                  <AccordionTrigger className="text-left py-4 hover:no-underline">Identificação dos Utilizadores</AccordionTrigger>
                  <AccordionContent className="text-gray-300 pb-4">
                    <p className="mb-2">Os utilizadores do Programa Dartsbeat Storepoint podem registar-se através do
                    site www.dartsbeatstore.pt, associando ai a sua conta Dartsbeat.</p>
                    
                    <p>O Programa Dartsbeat Storepoint reserva-se o direito de efetuar campanhas
                    especificamente para Portugal, dirigidas para os utilizadores registados.</p>
                  </AccordionContent>
                </AccordionItem>
                
                <AccordionItem value="item-5" className="border-b border-gray-700">
                  <AccordionTrigger className="text-left py-4 hover:no-underline">Rebatimento de Pontos</AccordionTrigger>
                  <AccordionContent className="text-gray-300 pb-4">
                    <p className="mb-2">Entende-se por rebatimento de pontos a troca dos mesmos por produtos ou serviços,
                    incluídos no Catálogo constante em dartsbeatstore.pt ou dartsbeatstore.com, ou ofertas
                    adicionais ao mesmo. O rebatimento de pontos implica necessariamente, e em todos os
                    casos, a diminuição do saldo de pontos na conta corrente storepoint, na mesma
                    quantidade que os pontos utilizados no rebatimento.</p>
                    
                    <p className="mb-2">Os pontos obtidos não poderão, em caso algum, ser trocados por dinheiro.</p>
                    
                    <p>O número de pontos necessário para rebater cada produto ou serviço incluídos no
                    Catálogo online, ou para rebater as ofertas adicionais ao mesmo, constará em cada
                    produto/serviço listado em www.dartsbeatstore.pt</p>
                  </AccordionContent>
                </AccordionItem>
                
                <AccordionItem value="item-6" className="border-b border-gray-700">
                  <AccordionTrigger className="text-left py-4 hover:no-underline">Rebatimento de produtos e serviços</AccordionTrigger>
                  <AccordionContent className="text-gray-300 pb-4">
                    <p className="mb-2">Para obter os produtos/serviços por rebatimento online, é obrigatório que o utilizador
esteja registado com um endereço de e-mail associado que utilize habitualmente, dado
que em alguns casos este endereço é imprescindível para realizar alterações ou
substituições. O utilizador poderá rebater os seus pontos no site www.dartsbeatstore.pt.
Receberá o produto/serviço, na morada que indicou para o efeito no seu perfil em
dartsbeatstote.pt, no prazo máximo de 20 dias a contar da data em que efetuou o
rebatimento.</p>
                    
                    <p className="mb-2">A oferta de produtos estará sempre, e em qualquer o caso, limitada aos stocks existentes.
Alguns produtos ou serviços podem não estar disponíveis devido à grande procura ou a
outras circunstâncias não previstas. Nestes casos, a Dartsbeat store reservam-se o direito
de substituir os produtos ou serviços por outros de marca, valor e qualidade similares, sem
anúncio ou aviso prévio.</p>
                    
                    <p className="mb-2">No ato de entrega dos produtos ou da prestação de serviço rebatidos, o programa
darstbeat storepoint, tem o direito de exigir ao possuidor da conta de rebatimentos de
pontos, um elemento comprovativo da sua identidade, sendo que a não apresentação
destes poderá inviabilizar a obtenção dos produtos ou serviços pretendidos.</p>
                    
                    <p className="mb-2">Os pontos não são em nenhuma circunstância convertíveis em dinheiro.</p>
                    
                    <p>Os pontos poderão também ser rebatidos para donativos a instituições indicadas no site
www.dartsbeatstore.pt, sendo o respetivo valor entregue diretamente pelo programa
darstbeat storepoint às entidades a que se destinam. Caso o utilizador pretenda receber
um recibo comprovativo do donativo efetuado, deverá enviar uma carta ao programa
Dartsbeat storepoint, indicando essa pretensão, bem como os seus dados pessoais,
incluindo o número de contribuinte,. O cliente terá 30 dias para solicitar o recibo, após ter
efetuado o rebatimento de pontos. O programa Dartsbeat storepoint solicitará esse recibo
junto da Instituição, devendo, depois, enviá-lo ao cliente.</p>
                  </AccordionContent>
                </AccordionItem>
                
                <AccordionItem value="item-7" className="border-b border-gray-700">
                  <AccordionTrigger className="text-left py-4 hover:no-underline">Duração</AccordionTrigger>
                  <AccordionContent className="text-gray-300 pb-4">
                    <p className="mb-2">Os pontos acumulados na app dartsbeat, só poderão ser utilizados no período de
                    vigência do Catálogo do programa Dasrtbeat Storepoint em vigor à data da obtenção dos
                    pontos.</p>
                    
                    <p className="mb-2">Sem prejuízo do previsto no número anterior, o programa Dartsbeat storepoint
                    reserva-se o direito de, a qualquer momento, pôr termo à presente promoção, anunciando-
                    o com três meses de antecedência.</p>
                    
                    <p>No caso de não ter havido qualquer transação utilizando de rebatimento de pontos há
                    48 meses ou mais, pontos constantes na conta storepoint do utilizador serão eliminados.</p>
                  </AccordionContent>
                </AccordionItem>
                
                <AccordionItem value="item-8" className="border-b border-gray-700">
                  <AccordionTrigger className="text-left py-4 hover:no-underline">Diversos</AccordionTrigger>
                  <AccordionContent className="text-gray-300 pb-4">
                    <p className="mb-2">Os empregados da darstbeat (e empresas associadas da darstbeat), revendedores,
                    concessionários, distribuidores, agentes, prestadores de serviços, bem como os
                    respetivos empregados e familiares, só podem reclamar brindes utilizando pontos
                    adquiridos através da utilização das máquinas Dartsbeat sob a forma de uso pessoal.</p>
                    
                    <p className="mb-2">O programa Dartsbeat Storepoint reserva-se o direito de, em qualquer momento,
                    alterar entidades terceiras participantes nesta promoção, sem anúncio ou aviso prévio.</p>
                    
                    <p className="mb-2">A promoção de pontos é gerida pela entidade com nome de operação comercial
                    Playglobal com sede e escritórios em Lisboa, Rua D. Antonio Caetano de Sousa 15B.</p>
                    
                    <p>O programada Dartsbeat Storepoint e Empresas Participantes não se responsabilizam
                    por qualquer erro tipográfico constante nos descritivos dos produtos e/ou serviços
                    constantes em dartsbeatstore.pt.</p>
                  </AccordionContent>
                </AccordionItem>
                
                <AccordionItem value="item-9" className="border-b border-gray-700">
                  <AccordionTrigger className="text-left py-4 hover:no-underline">Conformidade SRIJ – Serviço de Regulação e Inspeção de Jogos</AccordionTrigger>
                  <AccordionContent className="text-gray-300 pb-4">
                    <p>As máquinas de setas Darstbeat em conformidade com o disposto no Decreto Lei Nº
                    310/2002 de 18 de Dezembro, alterado e republicado pelo decreto lei Nº 204/2012 de 29
                    de Agosto, não são classificadas como equipamentos de diversão. Neste sentido e de
                    acordo com parecer do departamento de planeamento e controlo da atividade de jogo do
                    Serviço de Regulação e Inspeção de Jogos (SRIJ) do Turismo de Portugal, com a referencia
                    SAI/2020/16437/SRIJ-DPCJ/PL de 12.06.2020, podem as maquinas de setas dartsbeat
                    usufruir da implementação da funcionalidade de rebatimento de pontos que se efectua no
                    corrente programa Dartsbeat Storepoints, vulgarmente conhecida como funcionalidade
                    "Redemption", uma vez que não existe dispositivo normativo que proíba a sua
                    implementação.</p>
                  </AccordionContent>
                </AccordionItem>
              </Accordion>
              
              <div className="mt-8">
                <Button asChild className="bg-brand-red hover:bg-brand-red/90">
                  <Link to="/contact">{t('about.contactUs')}</Link>
                </Button>
              </div>
            </div>
            
            <div className="order-1 lg:order-2">
              <img 
                src="/lovable-uploads/sobredarts.webp" 
                alt="DartsBeat Portugal" 
                className="w-full h-auto rounded-lg shadow-lg"
              />
            </div>
          </div>
          
          <AppPromo />
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default AboutUs;
